import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import api from "../../services/api";
import { Grid, Stack } from "@mui/material";

const useStyles = makeStyles(theme => ({
  btnWrapper: { position: "relative" },
}));

const FlowBuilderRemoveKanbanModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const [activeModal, setActiveModal] = useState(false);
  const [lanes, setLanes] = useState([]);
  const [selectedLane, setSelectedLane] = useState("");

  useEffect(() => {
    if (open === "edit" || open === "create") {
      (async () => {
        try {
          const { data: res } = await api.get("/tag/kanban");
          const fetchedLanes = res.lista || [];
          setLanes(fetchedLanes);
          if (open === "edit" && data?.data?.tag) setSelectedLane(data.data.tag.id);
          else setSelectedLane("");
          setActiveModal(true);
        } catch (e) { console.log(e); }
      })();
    }
    return () => { isMounted.current = false; };
  }, [open]);

  const handleClose = () => { close(null); setActiveModal(false); };

  const handleSave = () => {
    if (!selectedLane) return toast.error("Selecione uma lane do kanban");
    const lane = lanes.find(l => l.id === selectedLane);
    if (open === "edit") {
      onUpdate({ ...data, data: { tag: lane } });
    } else {
      onSave({ tag: lane });
    }
    handleClose();
  };

  return (
    <Dialog open={activeModal} onClose={handleClose} fullWidth="md" scroll="paper">
      <DialogTitle>{open === "create" ? "Remover Lane Kanban" : "Editar Lane a Remover"}</DialogTitle>
      <Stack>
        <DialogContent dividers>
          <Grid style={{ width: "100%", marginTop: 16 }} container>
            <Typography style={{ marginBottom: 8, fontWeight: 600 }}>Qual lane remover do ticket?</Typography>
            <Select value={selectedLane} style={{ width: "95%" }} onChange={e => setSelectedLane(e.target.value)}
              MenuProps={{ anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, getContentAnchorEl: null }}
              renderValue={() => { if (!selectedLane) return "Selecione uma lane"; const l = lanes.find(l => l.id === selectedLane); return l ? l.name : "Nenhuma"; }}>
              <MenuItem value=""><em>Selecione uma lane</em></MenuItem>
              {lanes.map((lane, i) => (
                <MenuItem key={i} value={lane.id}>
                  <span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", background: lane.color || "#EF4444", marginRight: 8 }} />
                  {lane.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">Cancelar</Button>
          <Button onClick={handleSave} color="primary" variant="contained" style={{ background: "#EF4444" }}>{open === "create" ? "Remover" : "Salvar"}</Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
export default FlowBuilderRemoveKanbanModal;
